<template>
  <div style="padding: 5px">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="elevation-3 dash-card" style="padding: 10px">
          <h3>Statistiche Utenti</h3>
          <h4>Ios: {{ stats[0].Count }}</h4>
          <h4>Android: {{ stats[1].Count }}</h4>
        </v-card>
        <v-card class="elevation-3 dash-card">
          <v-toolbar
            class="q-orange-bk q-text-whitesmoke elevation-1"
            style="height: 50px"
          >
            <v-toolbar-title style="padding-bottom: 15px">
              <h3>{{ getString("Lista utenti App") }}</h3>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout>
              <v-btn class="q-orange-bk q-text-whitesmoke" @click="getUserApp">
                <v-icon>refresh</v-icon>
              </v-btn>
              <v-flex xs12 lg12>
                <v-text-field
                  type="text"
                  v-model="search"
                  :label="getString('Filtra')"
                  solo
                  color="red lighten-3"
                />
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="Headers"
              :items="userapp"
              item-key="idUser"
              :search="search"
              :rows-per-page-items="[
                10,
                25,
                50,
                100,
                { text: getString('Tutto'), value: -1 },
              ]"
              :rows-per-page-text="getString('Negozi per pagina')"
              :no-data-text="getString('Dati non disponibili')"
              :loading="loading"
              class="elevation-0"
            >
              <template slot="items" slot-scope="props">
                <tr
                  style="max-height: 100px; overflow: hidden; cursor: pointer"
                  :class="{
                    'q-disabled-bk': props.item.expired > 0,
                    'q-text-whitesmoke': props.item.expired > 0,
                  }"
                >
                  <td
                    @click="props.expanded = !props.expanded"
                    class="text-xs-left"
                  >
                    {{ props.item.idUser }}
                  </td>
                  <td>
                    <v-list-tile-avatar>
                      <img :src="defaultAvatar(props.item.photo)" />
                    </v-list-tile-avatar>
                  </td>
                  <td
                    @click="props.expanded = !props.expanded"
                    class="text-xs-left"
                  >
                    {{ props.item.name }}
                  </td>
                  <td
                    @click="props.expanded = !props.expanded"
                    class="text-xs-left"
                  >
                    {{ props.item.surname }}
                  </td>
                  <td class="text-xs-left">{{ props.item.email }}</td>
                  <td class="text-xs-left">{{ props.item.phone }}</td>
                  <td class="text-xs-left">{{ props.item.active }}</td>
                  <td class="text-xs-center" @click="enableUser(props.item)">
                    <v-btn flat>
                      <v-icon>remove_circle</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ajax from "../../../ajax";
import Utils from "../../../utils";
var ut = new Utils();
export default {
  name: "AdminApp",
  mounted: function () {
    this.init();
  },
  computed: {
    notEmpty: function () {
      return [(v) => !!v || this.getString("Campo richiesto")];
    },
    emailRule: function () {
      return [
        (v) => !!v || this.getString("Campo richiesto"),
        (v) => ut.ValidateEmail(v) || this.getString("Email non valida"),
      ];
    },
    numRule: function () {
      return [
        (v) => !!v || this.getString("Campo richiesto"),
        (v) =>
          ut.ValidateNumber(v) ||
          this.getString("Numero non valido, torniamo a scuola per cortesia?"),
      ];
    },
    locale: function () {
      return this.$store.state.currentTranslator.locale;
    },
    Headers: function () {
      let result = [];
      let self = this;
      if (this.userapp.length > 0) {
        let temp = [
          self.getString("Id:idUser"),
          self.getString("Foto"),
          self.getString("Nome:name"),
          self.getString("Cognome:surname"),
          self.getString("Email:email"),
          self.getString("Telefono:phone"),
          self.getString("Stato:active"),
          self.getString("Disabilita"),
        ];
        temp.forEach((element) => {
          result.push({
            text: self.getString(element.split(":")[0]),
            align: element.split(":").length > 1 ? "left" : "center",
            sortable: element.split(":").length > 1,
            value: element.split(":")[1],
          });
        });
        return result;
      }
      return [];
    },
  },
  data: () => {
    return {
      h: null,
      active: null,
      userapp: [],
      search: null,
      loading: false,
      selectedUser: {},
      noteDialog: false,
      currNote: "",
      stats: [
        {
          OS: "0",
          Count: 0,
        },
        {
          OS: "1",
          Count: 0,
        },
        {
          OS: "2",
          Count: 0,
        },
      ],
      dialogCost: 0,
      dialogDateMenu: false,
      dialogNote: "",
      dialogCheck: false,
      dialogDate:
        new Date().getFullYear() +
        "-" +
        ut.NumberWith0(new Date().getMonth() + 1) +
        "-" +
        ut.NumberWith0(1),
      newDialog: false,
      nameShopNewDialog: "",
      addressNewDialog: "",
      cityNewDialog: "",
      provNewDialog: "",
      capNewDialog: "",
      geoNewDialog: "",
      noteNewDialog: "",
    };
  },
  methods: {
    defaultAvatar: function (url) {
      if (
        url === null ||
        url === "images/u_placeholder.jpg" ||
        url === "/images/u_placeholder.jpg"
      ) {
        return "../../../../static/img/default-avatar.png";
      } else return ajax.baseUrl() + url;
    },
    init: function () {
      this.getUserApp();
      this.getUserAppStats();
    },
    getString: function (key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    enableUser: function (user) {
      let self = this;
      ajax.axios
        .put(
          ajax.baseUrl() + "/admin/man/enable/user/" + user.idUser,
          {
            enable: !user.isActive,
          },
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", response.data.data);
          self.loading = false;
          self.getUserApp();
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.loading = false;
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getUserApp: function () {
      let self = this;
      this.loading = true;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/man/getuserapp", {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true,
        })
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          let temp = response.data.data;
          self.loading = false;
          for (let index = 0; index < temp.length; index++) {
            let element = temp[index];
            if (!element.isActive) {
              element.active = self.getString("Disattivo");
            } else {
              element.active = self.getString("Attivo");
            }
          }
          self.userapp = temp;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.loading = false;
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getUserAppStats: function () {
      let self = this;
      this.loading = true;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/man/getuserappStats", {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true,
        })
        .then(function (response) {
          ajax.validateToken(response.headers);
          self.loading = false;
          self.stats = response.data.data;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.loading = false;
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
  },
};
</script>

<style>
.q-dark-bk {
  background-color: #424242 !important;
}

.q-dark-text {
  color: #f5f5f5 !important;
}

.q-light-bk {
  color: #f5f5f5 !important;
}

.q-light-text {
  color: #424242 !important;
}

.full-width {
  width: 100% !important;
}

h1,
h2,
h3 {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/AdminApp.vue